export const MODULE_NAMES = [
    "MatchSeekers",
    "Bride/GroomProfile",
    "Task/Issue",
    "ProfileChangeLogs",
    "Match Log",
    "Support",
    "NotificationAndAlerting",
    "CouponsAndDiscounts",
    "Connects",
    "ManageSubscriptionPlan",
    "ManageConnectsPricing",
    "ComplianceAndGovernance",
    "ContentManagement",
    "StaffAccessManagement",
    "Dashboard",
    "MasterDataManagement",
    "Payment History",
    "Reports",
    "ProfileVerification",
    "Events",
    "Bureau"
  ];

export const STAFF_BELONGS_TO = [
    'Marketing',
    'Customer Support',
    'Sales',
    'IT',
    'Human Resources',
    'Finance',
    'Operations',
    'Product',
    'Design',
    'Research',
];

export const MST_MODEL_NAMES = [
  'mst-annual-income',
  'mst-diettype',
  'mst-familytype',
  'mst-findmatchfor',
  'mst-gotram',
  'mst-profession',
  'mst-regiousbelief',
  'mst-skintone',
  'mst-religion',
  'mst-caste',
  'mst-subcaste',
  'mst-language',
  'mst-qualification',
  'mst-city',
  'mst-subscription-plan',
  'mst-heights',
  'mst-hi-categories',
  'mst-hi-sub-categories',
  'mst-location',
  'mst-operational-location',
  'mst-dosha',

  // Immutables
  'mst-profiletype',
  'mst-astrology-star',
  'mst-profession-sector',
  'mst-user-type',

  // New ones
  'mst-field-of-study',
  'mst-nakshatra',
  'mst-raashi',
  'mst-designation',
  'mst-father-details',
  'mst-mother-details',
  'mst-body-type',
  'mst-weight'
];
